<template>
  <div class="course-chapter-lessons">
    <el-row>
      <div class="model-header">
        <h2>Cập nhật chương / bài học khóa: {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row :gutter="10">
      <div class="model-content">
        <el-col :span="24">
          <div v-for="(category, index_1) in modelData.chapter_lessons" :key="category.key">
            <div class="header_1 header_line">
              <div class="d-flex justify-content-center align-items-center">
                <span style="display: block; min-width: 85px;">Chương {{ index_1 + 1}}</span>
                <el-input v-model="category.name" class="input-seach"></el-input>
              </div>
              <span class="delete-item" @click.prevent="removeCategory(category, modelData.chapter_lessons)">
                <i class="el-icon-delete"></i>
              </span>
            </div>
            <div style="padding-left: 80px;">
              <div v-for="(set) in category.options" :key="set.key">
                <div class="header_2 header_line">
                  <div>
                    <el-row :gutter="15">
                      <el-col :span="10">
                        <span class="title">Tên bài học</span>
                        <el-input v-model="set.name" class="input-seach"></el-input>
                        <span class="title">Thời gian</span>
                        <el-input v-model="set.time_video_txt" class="input-seach"></el-input>
                      </el-col>
                      <el-col :span="12">
                        <span class="title">Link video</span>
                        <el-input v-model="set.link_video" type="textarea" :rows="4" class="input-seach"></el-input>
                      </el-col>
                    </el-row>
                  </div>
                  <span class="delete-item" @click.prevent="removeSet(set, category.options)">
                    <i class="el-icon-delete"></i>
                  </span>
                </div>
              </div>
              <el-button class="huhu" type="info" size="mini" @click="addSet(category.options)"><i class="el-icon-circle-plus"></i> Thêm bài học</el-button>
            </div>
          </div>
          <el-button class="huhu" type="primary" size="mini" @click="addCategory()"><i class="el-icon-circle-plus"></i> Thêm chương</el-button>
        </el-col>
      </div>
    </el-row>
    <div style="padding-top: 20px">
      <el-button
        :disable="!canSubmit"
        :loading="!canSubmit"
        type="warning"
        size="small"
        @click="updateModel()">Cập nhật</el-button>
        <el-button
          size="small"
          class="btn-back"
          @click="backModel">Trở về
        </el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'CategoryBlogUpdate',
  metaInfo () {
    return {
      title: 'Khóa học'
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        id: '',
        chapter_lessons: [],
        status: false
      },
      homeMenu: []
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
  },
  methods: {
    clickLevel (item) {
      item.checked = !item.checked
      this.canSubmit = false
      setTimeout(() => {
        this.canSubmit = true
      }, 50)
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'courses-index', text: 'Khóa học' },
        { name: 'courses-update', text: 'Cập nhật' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'courses-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('courses/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          case 422:
            this.$router.push({name: 'home-index'})
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    updateModel () {
      this.canSubmit = false
      let data = {
        'chapter_lessons': this.modelData.chapter_lessons
      }
      console.log(this.modelData.chapter_lessons)
      axios.post('courses/update-chapter-lessons/' + this.$route.params.id, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            this.fetchModel()
            // this.$router.push({name: 'courses-show', params: {id: this.$route.params.id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    // ADD
    addCategory () {
      this.modelData.chapter_lessons.push({
        'key': Math.floor(Math.random() * 10000000000) + 1,
        'name': '',
        'chapter_id': null,
        'options': []
      })
    },
    removeCategory (item, options) {
      var index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
      }
    },
    addSet (option) {
      let temp = {
        'key': Math.floor(Math.random() * 10000000000) + 1,
        'name': '',
        'time_video_txt': '',
        'link_video': '',
        'lesson_id': null
      }
      option.push(temp)
    },
    removeSet (item, options) {
      var index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
      }
    }
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.huhu {
  /*margin-top: 10px;*/
  margin-bottom: 10px;
}
.course-chapter-lessons {

}
.header_1 {
  background-color: #eaeeaa;
  padding: 5px 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.header_1:hover {
  background-color: #dce283;
}
.header_1 .el-input {
  width: 500px;
}

.header_2 {
  background-color: #f8f8f8;
  padding: 10px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.header_2:hover {
  background-color: #f1f1f1;
}
.header_2 .el-textarea {
  width: 500px;
}
.header_2 .title {
  margin-bottom: 3px;
  margin-top: 3px;
  display: inline-block;
}
.delete-item {
  cursor: pointer;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/courses/Config.vue